<template lang="pug">
  div(class='yk-ap-wrapper8')
    div(class="yk-ap-head-info-wrapper" style="height:40px;border:0")
       div(class="yk-ap-que-name" style="color:#000")
          el-input.input-with-select(v-model='questionnireName' title='回车完成编辑'  v-if='isShowInput' @blur='hideTitleInput' @keyup.enter.native='hideTitleInput')
          div(v-else)
            label() {{showTitle}} 
            i.el-icon-edit(@click='showTitleInput' title='点击编辑问卷调查标题')
       div(class="yk-ap-que-btn-back") 
         el-button(type="primary" @click='returnPrevPage()' icon="wl-icon-fanhui2" class="yk-come-back-new-wrapper") 
    div(class='yk-ap-question clearfix')
      ol(class='clearfix yk-ap-que-ol-wrapper')
        li(v-for="(li,index) in list" :key="index")
          el-card(class="box-card yk-box-que-wrapper" v-if="index == list.length-1" id='target')
            div(slot="header" class="clearfix yk-ap-listhead")
              div(class="yk-que-show-intro")
                span(class="yk-que-name-index") {{index+1}}
                span(class='yk-ap-type') {{questionTypeName[li.questionType-1]}}
              div(class='yk-ap-operation')
                el-button(type="primary" icon="wl-icon-shangyi" size="mini"  @click="moveUp(index)" v-if="index !=0 ") 上移
                el-button(type="primary" icon="wl-icon-xiayi" size="mini" @click="moveDown(index)" v-if="index < list.length-1") 下移
                el-button(type="danger" icon="el-icon-delete"  size="mini" v-show="isquestion" @click="deleteQuestion(index,li.questionId)") 删除
            div( class='clearfix' v-if="true")
              true-false(:canuse="false" :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li' @submit='submitChildQuestion'  v-if="li.questionType >=3")
              SingleChoice(:canuse="false" :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li' @submit='submitChildQuestion' v-else)
          el-card(class="box-card yk-box-que-wrapper" v-else)
              div(slot="header" class="clearfix yk-ap-listhead")
                div(class="yk-que-show-intro")
                  span(class="yk-que-name-index") {{index+1}}
                  span(class='yk-ap-type') {{questionTypeName[li.questionType-1]}}
                div(class='yk-ap-operation')
                  el-button(type="primary" icon="wl-icon-shangyi" size="mini"  @click="moveUp(index)" v-if="index !=0 ") 上移
                  el-button(type="primary" icon="wl-icon-xiayi" size="mini" @click="moveDown(index)" v-if="index < list.length-1") 下移
                  el-button(type="danger" icon="el-icon-delete"  size="mini" v-show="isquestion" @click="deleteQuestion(index,li.questionId)") 删除
              div( class='clearfix' v-if="true")
                true-false(:canuse="false" :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li' @submit='submitChildQuestion'  v-if="li.questionType >=3")
                SingleChoice(:canuse="false" :isquestion="saveBtn" :iSubmit='iSubmit' :li.sync='li'  @submit='submitChildQuestion' v-else)
      div(class="box-card width_limit")
            div(class="yk-qu-add-question-title") 添加题目
            div(@click='addChoice(1)' class="yk-qu-question-type") 
              i(class="wl-icon-dian") 
              span(class="yk-que--s-name") 添加单选
              i(class="wl-icon-tianjia1")
            div(@click='addChoice(2)' class="yk-qu-question-type") 
              i(class="wl-icon-dian") 
              span(class="yk-que--s-name") 添加多选
              i(class="wl-icon-tianjia1")
            div(@click='addTrueFalse(3)' class="yk-qu-question-type") 
              i(class="wl-icon-dian") 
              span(class="yk-que--s-name") 正确错误
              i(class="wl-icon-tianjia1")
            div(@click='addTrueFalse(4)' class="yk-qu-question-type") 
              i(class="wl-icon-dian") 
              span(class="yk-que--s-name") 赞成反对
              i(class="wl-icon-tianjia1")
            div(class="yk-qu-question-type-btn")
              el-button(@click='sendAllRequest()' type="primary" style="width:100px;border-radius:6px;") 保存

</template>


<style lang="scss">
.yk-ap-wrapper8 {
  width: 100%;
  height: auto;
  padding-top: 15px;
  .yk-ap-head-info-wrapper {
    margin: 0 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #596880;
    line-height: 40px;
    .yk-ap-que-name {
      float: left;
      font-size: 18px;
      color: #fff;
      width:500px;
    }
    .yk-ap-que-btn-back {
      float: right;
    }
  }
  .yk-ap-head-info-wrapper:after {
    content: "";
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
  }
  .yk-ap-header {
    width: 100%;
    height: 50px;
    // position: fixed;
    top: 60px;
    left: 0;
    z-index: 50;
    // box-shadow: #eee 2px 6px 6px 0px;
    a {
      line-height: 50px;
      font-size: 20px;
      color: #aaa;
      margin-left: 20px;
      text-decoration: none;
      display: block;
      float: left;
    }
    .yk-ap-condition {
      float: right;
      line-height: 50px;
      margin-right: 20px;
      .yk-condition {
        margin-right: 20px;
      }
    }
  }
  .yk-ap-question {
    ol {
      float: left;
      list-style: none;
      margin-left: 20px;
      width: calc(100% - 270px);
      height: auto;
      padding: 0;
      li {
        margin-top: 20px;
        float: left;
        width: 100%;
        .yk-ap-listhead {
          .yk-que-show-intro {
            float: left;
            font-size: 18px;
            .yk-que-name-index{
                display:inline-block;
                width:30px;
                height:30px;
                background-color: #fff;
                margin-right:10px;
                color:#293140;
                border-radius: 50%;
                text-align: center;
                line-height: 30px;
            }
          }
          .yk-ap-operation {
            float: right;
          }
          .yk-ap-diffcult {
            margin-left: 30px;
          }
          .yk-ap-operation {
            font-size: 20px;
            a {
              text-decoration: none;
              color: #303133;
            }
            a:hover {
              color: #409eff;
            }
          }
        }
        .yk-box-que-wrapper {
          background-color: #edf2f6;
          border: none;
          color: #000;
          border-radius: 10px;
          .el-card__header {
            border-bottom: 1px solid #596880;
          }
        }
      }
    }
    .yk-ap-aquestion {
      position: fixed;
      list-style: none;
      top: 100px;
      right: 30px;
      width: 150px;
      height: auto;
      cursor: pointer;
      .el-collapse-item__header {
        width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #409eff;
        text-align: center;
        color: #fff;
        i {
          line-height: 35px;
        }
      }
      li {
        width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #409eff;
        text-align: center;
        border-top: 1px solid #eee;
        a {
          color: #fff;
        }
      }
      li:hover {
        background-color: #316eae;
      }
    }
  }
  .width_limit {
    position: fixed;
    right: 11px;
    top: right;
    width: 210px;
    top: 150px;
    height: 315px;
    border-radius: 10px;
    .yk-qu-add-question-title {
      padding-left: 20px;
      height: 50px;
      background-color: #f7f7f7;
      border-radius: 10px 10px 0 0;
      border-bottom: 1px solid #5b6d8a;
      color: #333;
      font-size: 20px;
      line-height: 50px;
    }
    .yk-qu-question-type,
    .yk-qu-question-type-btn {
      height: 50px;
      background-color: #edf2f6;
      color: #000;
      border-bottom: 1px solid #fff;
      line-height: 50px;
      .yk-que--s-name {
        font-size: 18px;
        margin-right: 50px;
        margin-left: 10px;
      }
      .wl-icon-dian {
        margin-left: 20px;
      }
      .wl-icon-tianjia1 {
        color: #3f9ffa;
        font-size: 18px;
        border-radius: 50%;
        background-color: #edf2f6;
        border: 1px solid;
      }
    }
    .yk-qu-question-type-btn {
      text-align: center;
      height: 70px;
      line-height: 70px;
      border-radius: 0 0 10px 10px;
    }
  }
}
</style>


<script>
import Vue from 'vue';
import TrueFalse from 'page/xSchool/teachingMaterial/QuestionnaireQuestions/TrueFalse.vue';
import Multiselect from 'components/ObjectiveTest/Multiselect.vue';
import SingleChoice from 'page/xSchool/teachingMaterial/QuestionnaireQuestions/SingleChoice.vue';
import { 
  getQuestionnaireQueList, 
  deleteQuestionnaireQuestion, 
  updateQuestionnaireQuestion 
} from 'api/v1.manager.coursequestionnaire';
// @ts-ignore
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, options);
let options = {
  container: ".mc-home-work-wrapper", //滚动的容器
  duration: 500, //滚动时间
  easing: "ease", //缓动类型
  offset: 0, //滚动时应应用的偏移量。此选项接受回调函数
  force: true, //是否应执行滚动
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};
export default Vue.extend({
  name: 'questionnaire',
  components: {
    Multiselect,
    TrueFalse,
    SingleChoice
  },
  data() {
    return {
      activeNames: [],
      editable: false,
      praname: '第一次作业名称',
      condition: '未开始',
      changeCondition: '开始',
      quesNumber: '第一题',
      diffcult: 1,
      dialogVisible: false,
      type: '判断题',
      questionTypeName: ['单选题', '多选题', '判断题', '判断题'],
      watch: false,
      del: false,
      number: 5,
      list: [],
      dataJson: [],
      queTitle: '',
      queId: '',
      quesType: 1,
      answerType: 1,
      saveBtn: false,
      submitCount: 0,
      successCount: 0,
      submitmsg: '',
      iSubmit: false,
      questionnireName: '',
      showTitle: '',
      isShowInput: false,
      submitName: '',
      allowClick: true
    };
  },
  props: {
    questionnaireId: {
      type: String,
      default: '0'
    },
    schoolCourseId: {
      type: String,
      default: ''
    },
    isquestion: {
      type: Boolean,
      default: true
    },
    courseId: {
      type: String,
      default: ''      
    },
    userType:{
      type: [Number,String],
      default: 0
    }
  },
  watch: {
    list: {
      handler() {
        console.log(this.list);
      },
      deep: true
    },
    schoolCourseId(val) {
      console.log(val);
    },
    questionnaireId: function(val) {
      this.getQuestionnaireQuesList();
    },
    questionnireName: function(val) {
      this.showTitle = val;
      this.submitName = val;
    }
  },
  created() {
    this.getQuestionnaireQuesList();
  },
  methods: {
    deleteQuestion: function(index, id) {
      let askMessage = '是否删除该题目?';
      let questionnaireId = '';
      if (this.list.length == 1) {
        askMessage = '删除最后一题会自动删除问卷调查哦~';
        questionnaireId = this.questionnaireId;
      }

      this.$confirm(askMessage, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteQuestionnaireQuestion(id, questionnaireId).then(rst => {
          if (rst.code >0) {
            this.list.splice(index, 1);
            this.$message({
              type: 'success',
              message: rst.msg
            });
            if (this.list.length == 0) {
              this.returnPrevPage();
            }
          } else {
            this.$message({
              type: 'warning',
              message: rst.msg
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addChoice: function(type) {
      let order = this.list.length + 1;
      this.list.push({
        ContentText: '',
        questionType: type,
        questionId: '',
        dataJson: [
          {
            Content: '',
            SortOrder: 0
          },
          {
            Content: '',
            SortOrder: 1
          },
          {
            Content: '',
            SortOrder: 2
          },
          {
            Content: '',
            SortOrder: 3
          }
        ],
        sortOrder: order
      });
      this.gotoTarget();
    },
    addTrueFalse: function(type) {
      let order = this.list.length + 1;
      let contents = type == 3 ? ['正确', '错误'] : ['赞成', '反对'];
      this.list.push({
        ContentText: '',
        questionType: type,
        questionId: '',
        sortOrder: order,
        dataJson: [
          {
            Content: contents[0]
          },
          {
            Content: contents[1]
          }
        ]
      });
      this.gotoTarget();
    },
    getQuestionnaireQuesList: function() {
      let schoolCourseId=this.schoolCourseId;
      let questionnaireId = this.questionnaireId;
      getQuestionnaireQueList(schoolCourseId, questionnaireId).then(rst => {
        this.list = rst.data;
        this.questionnireName = rst.title;
        this.allowClick = true;
      });
    },
    returnPrevPage: function() {
      this.$router.push({
        name: 'teaShareSurveyCourse',
        params: {
          schoolCourseId: this.schoolCourseId
        }
      });
      // this.$router.go(-1);
    },
    moveUp: function(index) {
      // 上移题目
      let temp = this.list[index];
      this.list[index] = this.list[index - 1];
      this.list[index - 1] = temp;
      this.list[index - 1].sortOrder = index;
      this.list[index].sortOrder = index + 1;
      this.list.push({ code: 1 });
      this.list.pop();
    },
    moveDown: function(index) {
      // 下移题目
      let temp = this.list[index];
      this.list[index] = this.list[index + 1];
      this.list[index + 1] = temp;
      this.list[index + 1].sortOrder = index + 2;
      this.list[index].sortOrder = index + 1;
      this.list.push({ code: 1 });
      this.list.pop();
    },
    sendAllRequest() {
      if (!this.allowClick) {
        this.$message('请不要老是点我啦~');
        return;
      }
      if (this.list.length == 0) {
        this.$message('您至少添加一题才能保存哦~');
      } else {
        // 向子页面发送提交事件的命令
        this.iSubmit = true;
        this.allowClick = false;
      }
    },
    submitChildQuestion: function(obj) {
      // 子页面返回数据的个数
      this.submitCount = this.submitCount + obj.count;
      // 子页面通过数据验证的个数
      this.successCount = this.successCount + obj.code;
      if (obj.code == 0) {
        this.submitmsg = this.submitmsg + obj.msg + '<br />';
      }

      if (this.list.length == this.submitCount) {
        this.iSubmit = false;
        if (this.list.length == this.successCount) {
          let questionJson = JSON.stringify(this.list);
          updateQuestionnaireQuestion(this.schoolCourseId,this.courseId, this.questionnaireId, this.submitName, questionJson,this.userType).then(rst => {
            if (rst.questionnaireId) {
              this.$router.push({
                name: 'teaShareSurveyCourse',
                params: {
                  questionnaireId: rst.questionnaireId,
                  schoolCourseId: this.schoolCourseId
                }
              });
              this.getQuestionnaireQuesList();
            } else {
              this.allowClick = true;
            }

            if (rst.code > 0) {
              this.$message(rst.msg);
            } else {
              this.$message(rst.msg);
            }
          });
        } else {
          this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: this.submitmsg
          });
          this.allowClick = true;
        }
        this.submitCount = 0;
        this.successCount = 0;
        this.submitmsg = '';
      }
    },
    gotoTarget: function() {
      this.$scrollTo('#target', 100, {
        offset: 500
      });
    },
    showTitleInput: function() {
      this.isShowInput = true;
    },
    hideTitleInput: function() {
      this.isShowInput = false;
    }
  },
});
</script>
